import classNames from 'classnames';
import { useEffect, useId, useState } from 'react';

import { paths } from '@farmersdog/constants';
import {
  Box,
  Button,
  GridContainer,
  Text,
  useViewport,
  type TextVariant,
} from '@farmersdog/corgi-x';

import styles from './BuildYourPlanCard.css';
import { PlanStep } from './PlanStep';
import { planStepData } from './planStepData';

export interface BuildYourPlanCardProps {
  breed: string;
  className?: string;
}

export function BuildYourPlanCard({
  breed,
  className,
}: BuildYourPlanCardProps) {
  const id = useId();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-52'
    : 'heading-40';

  return (
    <Box
      as="figure"
      aria-labelledby={id}
      m={0}
      className={classNames(styles.card, className)}
    >
      <Text
        className={styles.title}
        id={id}
        variant={titleVariant}
        weight="bold"
        as="h2"
        color="kale-3"
      >
        Build a plan for your {breed}
      </Text>
      <Text
        className={styles.description}
        variant="article-20"
        as="p"
        color="charcoal-3"
      >
        Your {breed} will do best on a diet of nutrient-dense food made from
        fresh, whole ingredients.
      </Text>
      <GridContainer as="ul" aria-labelledby={id} className={styles.grid}>
        {planStepData.map(planStep => {
          return <PlanStep key={planStep.step} {...planStep} />;
        })}
      </GridContainer>
      <Button
        className={styles.cta}
        variant="primary"
        type="anchor"
        href={paths.PATH_SIGNUP}
      >
        Build Your Plan
      </Button>
    </Box>
  );
}
